<template>
  <div class="cell">
    <div class="cell-left">{{cellName}}<slot name="title"></slot></div>
    <div class="cell-right">{{cellValue}}<slot name="value"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cell',
  props: ['cellName', 'cellValue'],
};
</script>

<style>
</style>
